import React from 'react';
import './Sidebar.css';

const Sidebar = ({ isOpen, currentPage, onPageChange, onClose }) => {
  const menuItems = [
    { id: 'calculate', label: 'Calculate', icon: '🧮' },
    { id: 'tenants', label: 'Tenants', icon: '👥' },
    { id: 'history', label: 'History', icon: '📊' },
    { id: 'settings', label: 'Settings', icon: '⚙️' }
  ];

  const handleItemClick = (pageId) => {
    onPageChange(pageId);
    onClose();
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}
      <nav className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <ul className="sidebar-menu">
          {menuItems.map(item => (
            <li key={item.id} className="sidebar-item">
              <button
                className={`sidebar-link ${currentPage === item.id ? 'active' : ''}`}
                onClick={() => handleItemClick(item.id)}
              >
                <span className="sidebar-icon">{item.icon}</span>
                <span className="sidebar-label">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;